import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import FinMark from '../brand/FinMark';
import { TelegramCta } from './primitives';
import { landing } from './tokens';

const sections = [
  { href: '#como-funciona', key: 'howItWorks' },
  { href: '#grupos', key: 'groups' },
  { href: '#recursos', key: 'features' },
  { href: '#perguntas', key: 'faq' },
];

const LandingNav: React.FC = () => {
  const { t } = useTranslation('landing');
  return (
    <Box
      component='header'
      sx={{
        position: 'sticky',
        top: 0,
        zIndex: 20,
        bgcolor: 'rgba(250, 250, 248, 0.86)',
        backdropFilter: 'blur(12px)',
        borderBottom: `1px solid ${landing.line}`,
      }}
    >
      <Box
        sx={{
          maxWidth: landing.maxWidth,
          mx: 'auto',
          px: 3,
          py: 1.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 2,
        }}
      >
        <Box
          component='a'
          href='#topo'
          aria-label={t('nav.home')}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.25,
            color: landing.ink,
            textDecoration: 'none',
          }}
        >
          <FinMark size={34} />
          <Box
            component='span'
            sx={{
              fontFamily: landing.display,
              fontWeight: 700,
              fontSize: 23,
              letterSpacing: '-0.02em',
            }}
          >
            Financy
          </Box>
        </Box>

        <Box
          component='nav'
          aria-label={t('nav.sections')}
          sx={{ display: { xs: 'none', md: 'flex' }, gap: 3.5 }}
        >
          {sections.map((section) => (
            <Box
              key={section.key}
              component='a'
              href={section.href}
              sx={{
                color: landing.ink2,
                textDecoration: 'none',
                fontSize: 15,
                '&:hover': { color: landing.ink },
              }}
            >
              {t(`nav.${section.key}`)}
            </Box>
          ))}
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
          <Box
            component={RouterLink}
            to='/login'
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              minHeight: 44,
              px: 1.75,
              borderRadius: '999px',
              color: landing.ink,
              textDecoration: 'none',
              fontWeight: 600,
              fontSize: 15,
              '&:hover': { bgcolor: landing.bg2 },
            }}
          >
            {t('nav.login')}
          </Box>
          <TelegramCta
            label={t('nav.cta')}
            size='sm'
            sx={{ display: { xs: 'none', sm: 'inline-flex' } }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default LandingNav;
